import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const ContableRegistroGastoRow=({contableregistrogasto, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{contableregistrogasto.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{contableregistrogasto.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/contableregistrogasto/"+contableregistrogasto.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(contableregistrogasto.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={contableregistrogasto.idEstatus==1?'x':'check'} link  size="large" 
                                                color={contableregistrogasto.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(contableregistrogasto.id)} 
                                            />
                                        }
                                        content={contableregistrogasto.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default ContableRegistroGastoRow;